import Big from 'big.js';
import { DateTime } from 'luxon';
import * as session from 'smg/customer-api/session';
import * as models from 'smg/models';
import { RemToPx } from 'smg/rem';
import * as column from 'smg/table/column';
import * as tableLib from 'smg/table/table';
import { Relref } from '../hugo';
import * as search from '../search';

declare interface resp {
    shipments: models.Shipment[];

    carriers: models.Carrier[];
}

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    type r = models.Shipment;
    type c = keyof r;
    type d = 'carriers';

    const carriers: Record<string, models.Carrier> = {};

    class table extends tableLib.Table<r, c, d> {
        RowHeight = RemToPx(parseFloat(getComputedStyle(document.querySelector('.iap-table') as HTMLElement).getPropertyValue('--row-height'))) + 1;

        RowsPerPage = 100;

        GetRowsFromResponse = (d: resp) => {
            tableLib.Table.Map(carriers, d.carriers);

            return d.shipments;
        };

        constructor() {
            super('/shipments', search.Input as HTMLInputElement, search.Form as HTMLFormElement);

            this.AddColumns(
                new column.ColumnID(),
                new column.Column({
                    name: 'Tracking Number',
                    width: '16rem',
                    columns: ['trackingNumber', 'carrierID'],
                    data: ['carriers'],
                    draw: (td, r) => {
                        if (!r.trackingNumber) {
                            return;
                        }

                        const carrier = carriers[r.carrierID || -1];
                        if (!carrier?.link) {
                            td.textContent = r.trackingNumber;
                            return;
                        }

                        const a = document.createElement('a');
                        a.href = carrier.link.replace('%%', r.trackingNumber);
                        a.textContent = r.trackingNumber;

                        td.appendChild(a);

                        // td.appendChild(document.createTextNode(` via ${carrier.name}`));
                    },
                    text: r => r.trackingNumber || '',
                }),
                new column.Column({
                    name: 'Carrier',
                    width: '10rem',
                    columns: ['carrierID'],
                    data: ['carriers'],
                    text: r => carriers[r.carrierID || -1]?.name || '',
                }),
                new column.Column({
                    name: 'Status',
                    width: 10,
                    columns: ['shipped', 'delivered'],
                    draw: (td, r) => {
                        if (r.delivered) {
                            td.classList.add('text-success');
                            td.textContent = `Delivered - ${DateTime.fromISO(r.delivered).toLocaleString(DateTime.DATETIME_SHORT)}`;
                            return;
                        } else if (r.shipped) {
                            td.textContent = `Shipped - ${DateTime.fromISO(r.shipped).toLocaleString(DateTime.DATETIME_SHORT)}`;
                            return;
                        }

                        td.textContent = 'Not Yet Shipped';
                    },
                }),
                new column.ColumnNumber({
                    name: 'Weight',
                    column: 'weightLBS',
                    width: '5rem',
                    text: r => {
                        const w = Big(r.weightLBS || 0);
                        if (w.eq(0)) {
                            return '';
                        }

                        return `${w.round(1).toString()}lbs`;
                    },
                }),
                new column.Column({
                    name: 'Order',
                    width: '10rem',
                    columns: 'order',
                    draw: (td, r) => {
                        if (!r.order) {
                            return;
                        }

                        td.classList.add('d-flex', 'flex-direction-column');

                        const a = document.createElement('a');
                        a.textContent = `#${r.order.invoiceNumber || ''}`;
                        a.href = `/orders/?q=${r.order.invoiceNumber || ''}`;

                        td.appendChild(a);
                    },
                    text: r => String(r.order?.invoiceNumber || ''),
                }),
                new column.ColumnDateTime({
                    name: 'Date',
                    width: '7rem',
                    sortDirection: 'desc',
                }),
            );

            this.EnableAutoUpdating(10 * 60 * 1000);
        }
    }

    const t = new table();

    void t.Build();
}